// Competitive advantage section configuration
// Defines fields for differentiation and barriers to entry
import { z } from 'zod';
import type { SectionConfig } from '../../types/sections';

// Validation schema for competitive advantage section
export const competitiveAdvantageSectionSchema = z.object({
  hardToCopy: z.string().min(1, 'Este campo es requerido'),
  proprietaryTechnology: z.string().min(1, 'Este campo es requerido'),
  entryBarriers: z.string().optional(),
});

export type CompetitiveAdvantageSectionData = z.infer<typeof competitiveAdvantageSectionSchema>;

// Section config
export const competitiveAdvantageSection: SectionConfig = {
  id: 'competitiveAdvantage',
  titleKey: 'Ventaja competitiva / diferenciación',
  descriptionKey: 'Describe qué hace único a tu producto o servicio',
  validationSchema: competitiveAdvantageSectionSchema,
  fields: [
    {
      name: 'hardToCopy',
      type: 'textarea',
      label: '¿Qué te hace difícil de copiar?',
      placeholder: 'Describe tus ventajas competitivas únicas...',
      required: true,
    },
    {
      name: 'proprietaryTechnology',
      type: 'textarea',
      label: '¿Tienes tecnología propia, data, know-how?',
      placeholder: 'Describe tu tecnología, datos o conocimiento propietario...',
      required: true,
    },
    {
      name: 'entryBarriers',
      type: 'textarea',
      label: '¿Existen barreras de entrada?',
      placeholder: 'Describe las barreras que protegen tu mercado...',
      required: false,
    },
  ],
};
